import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const listShippingRates = (cartId, stateCode, countryCode, zipCode) =>
  axios.get(
    `${getV2RootUrl()}/cart/${cartId}/shipping-rate?stateCode=${stateCode}&countryCode=${countryCode}&zipCode=${zipCode}`,
    publicAxiosHeaderV2()
  );

export const listShippingAvailability = () =>
  axios.get(
    `${getV2RootUrl()}/shipping-availability/for-web`,
    publicAxiosHeaderV2()
  );
